export enum NotificationAccordionTypes {
  INFO = 'info',
  HELP = 'help',
}
